export function loadGoogleCharts(): Promise<void>
{
    return new Promise((resolve, reject) =>
    {
        if (typeof (window as any).google !== "undefined" && (window as any).google.charts)
        {
            resolve();
            return;
        }

        const script = document.createElement("script");
        script.src = "https://www.gstatic.com/charts/loader.js";
        script.onload = () =>
        {
            (window as any).google.charts.load("current", { packages: ["orgchart"] });
            (window as any).google.charts.setOnLoadCallback(() => resolve());
        };
        script.onerror = () => reject(new Error("Failed to load Google Charts"));
        document.head.appendChild(script);
    });
}
